import StudyGuide from '@/pages/StudyGuide';
import StudentSearch from '@/pages/ogrenci/Search';
import Notifications from '@/pages/ogrenci/Notifications';
import InstitutionApplication from '@/pages/kurum/Application';
import InstitutionLogin from "@/pages/kurum/Login";
import InstitutionPanel from "@/pages/kurum/Panel";
import InstitutionAdmin from "@/pages/kurum/Admin";
import InstitutionRedeem from "@/pages/kurum/Redeem";
import LearningContent from "@/pages/admin/LearningContent";
import TopicLibrary from "@/pages/konu-anlatimlari";
import { ExperienceWelcome } from "@/components/feature/mobile/Experience";
import { Navigate, useParams, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import About from '@/pages/hakkimizda/page';
import Help from '@/pages/yardim/page';
import Home from "@/pages/home/page";
import StudentLayout from "@/pages/ogrenci/components/StudentLayout";
import StudentDashboard from "@/pages/ogrenci/page";
import Derslerim from "@/pages/ogrenci/derslerim/page";
import CanliDersler from "@/pages/ogrenci/canli-dersler/page";
import CanliDersKayit from "@/pages/ogrenci/canli-ders-kayit/page";
import MerakliCanliDers from "@/pages/merakli/canli-ders/page";
import DersKayitlari from "@/pages/ogrenci/ders-kayitlari/page";
import Yoklama from "@/pages/ogrenci/yoklama/page";
import DersProgramim from "@/pages/ogrenci/ders-programim/page";
import VideoDersler from "@/pages/ogrenci/video-dersler/page";
import SoruBankasi from "@/pages/ogrenci/soru-bankasi/page";
import SoruBankasiTest from "@/pages/ogrenci/soru-bankasi/test/page";
import DenemeSinavlari from "@/pages/ogrenci/deneme-sinavlari/page";
import DenemePage from "@/pages/ogrenci/deneme/page";
import DenemeSonucPage from "@/pages/ogrenci/deneme-sonuc/page";
import Odevler from "@/pages/ogrenci/odevler/page";
import YanlisSorularim from "@/pages/ogrenci/yanlis-sorularim/page";
import Favorilerim from "@/pages/ogrenci/favorilerim/page";
import Notlarim from "@/pages/ogrenci/notlarim/page";
import BasariAnalizim from "@/pages/ogrenci/basari-analizim/page";
import Ogretmenlerim from "@/pages/ogrenci/ogretmenlerim/page";
import Mesajlar from "@/pages/ogrenci/mesajlar/page";
import Sertifikalar from "@/pages/ogrenci/sertifikalar/page";
import Paketim from "@/pages/ogrenci/paketim/page";
import Profilim from "@/pages/ogrenci/profilim/page";
import MotivasyonPage from "@/pages/ogrenci/motivasyon/page";
import PomodoroPage from "@/pages/ogrenci/pomodoro/page";
import HaftalikPlanPage from "@/pages/ogrenci/haftalik-plan/page";
import HedeflerimPage from "@/pages/ogrenci/hedeflerim/page";
import ComingSoon from "@/pages/ogrenci/components/ComingSoon";
import OgretmenLayout from "@/pages/ogretmen/components/OgretmenLayout";
import OgretmenDashboard from "@/pages/ogretmen/page";
import Ogrencilerim from "@/pages/ogretmen/ogrencilerim/page";
import OgretmenDerslerim from "@/pages/ogretmen/derslerim/page";
import OgretmenCanliDersler from "@/pages/ogretmen/canli-dersler/page";
import OgretmenDersProgramim from "@/pages/ogretmen/ders-programim/page";
import OgretmenVideoDersler from "@/pages/ogretmen/video-dersler/page";
import AiVideoDers from "@/pages/ogretmen/ai-video-ders/page";
import SoruEkle from "@/pages/ogretmen/soru-ekle/page";
import TestOlustur from "@/pages/ogretmen/test-olustur/page";
import DenemeOlustur from "@/pages/ogretmen/deneme-olustur/page";
import OgretmenOdevler from "@/pages/ogretmen/odevler/page";
import OgrenciAnalizleri from "@/pages/ogretmen/ogrenci-analizleri/page";
import OgretmenAiGecmisi from "@/pages/ogretmen/ai-gecmisi/page";
import OgretmenMesajlar from "@/pages/ogretmen/mesajlar/page";
import OgretmenProfil from "@/pages/ogretmen/profil/page";
import VeliLayout from "@/pages/veli/components/VeliLayout";
import VeliDashboard from "@/pages/veli/page";
import VeliDersler from "@/pages/veli/dersler/page";
import VeliDenemeSonuclari from "@/pages/veli/deneme-sonuclari/page";
import VeliOdevler from "@/pages/veli/odevler/page";
import VeliDevamsizlik from "@/pages/veli/devamsizlik/page";
import VeliHaftalikRapor from "@/pages/veli/haftalik-rapor/page";
import VeliAiAnaliz from "@/pages/veli/ai-analiz/page";
import VeliMesajlar from "@/pages/veli/mesajlar/page";
import VeliProfil from "@/pages/veli/profil/page";
import VeliMerakliKontrolu from "@/pages/veli/merakli-kontrolu/page";
import PanelNotFound from "@/components/feature/panel/PanelNotFound";
import AdminLayout from "@/pages/admin/components/AdminLayout";
import AdminDashboard from "@/pages/admin/page";
import AdminKullanicilar from "@/pages/admin/kullanicilar/page";
import AdminRoller from "@/pages/admin/roller/page";
import AdminIcerikler from "@/pages/admin/icerikler/page";
import AdminCanliDersler from "@/pages/admin/canli-dersler/page";
import AdminSinavlar from "@/pages/admin/sinavlar/page";
import AdminPaketler from "@/pages/admin/paketler/page";
import AdminOdemeler from "@/pages/admin/odemeler/page";
import AdminBorclular from "@/pages/admin/borclular/page";
import AdminSmsBildirim from "@/pages/admin/sms-bildirim/page";
import AdminDestek from "@/pages/admin/destek/page";
import AdminDenetimKaydi from "@/pages/admin/denetim-kaydi/page";
import AdminAyarlar from "@/pages/admin/ayarlar/page";
import AiYonetimi from "@/pages/admin/ai-yonetimi/page";
import CategoryPage from "@/components/feature/CategoryPage";
import ExamDetailPage from "@/components/feature/ExamDetailPage";
import ShortExamPage from "@/components/feature/ShortExamPage";
import LevelDetailPage from "@/components/feature/LevelDetailPage";
import LegalPage from "@/components/feature/LegalPage";
import OnlineDershane from "@/pages/online-dershane/page";
import OnlineDenemeSinavi from "@/pages/online-deneme-sinavi/page";
import Sinavlar from "@/pages/sinavlar/page";
import Siniflar from "@/pages/siniflar/page";
import Paketler from "@/pages/paketler/page";
import Iletisim from "@/pages/iletisim/page";
import Giris from "@/pages/giris/page";
import Kayit from "@/pages/kayit/page";
import SifremiUnuttum from "@/pages/sifremi-unuttum/page";
import SifreSifirla from "@/pages/sifre-sifirla/page";
import OgretmenGiris from "@/pages/ogretmen/giris/page";
import AdminGiris from "@/pages/admin/giris/page";
import { categories } from "@/data/content";

// Eski yönetim adreslerini yeni /yonetici yoluna taşır (alt yolu korur).
import LegacyAdminRedirect from "./LegacyAdminRedirect";

import ProgramDetail from "@/pages/programlarimiz/ProgramDetail";
import Programs from "@/pages/programlarimiz/page";
const routes: RouteObject[] = [
  { path: "/kurum/basvuru", element: <InstitutionApplication /> },
  { path: "/kurum/giris", element: <InstitutionLogin /> },
  { path: "/kurum/aktivasyon", element: <InstitutionRedeem /> },
  { path: "/kurum", element: <InstitutionPanel /> },
  {path:"/programlarimiz",element:<Programs/>},
  {path:"/programlarimiz/:slug",element:<ProgramDetail/>},
  {path: "/konu-anlatimlari/rehber/:topic", element: <StudyGuide />},
  {path: "/konu-anlatimlari", element: <TopicLibrary />},
  {path: "/konu-anlatimlari/:slug", element: <TopicLibrary />},
  {
    path: "/merakli/canli-ders/:id",
    element: <MerakliCanliDers />,
  },
  { path: "/mobil", element: <div style={{minHeight:"100dvh",background:"#26213d",display:"flex",justifyContent:"center"}}><ExperienceWelcome /></div> },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ogrenci",
    element: <StudentLayout />,
    children: [
      {
        index: true,
        element: <StudentDashboard />,
      },
      {
        path: "motivasyon",
        element: <MotivasyonPage />,
      },
      {
        path: "pomodoro",
        element: <PomodoroPage />,
      },
      {
        path: "haftalik-plan",
        element: <HaftalikPlanPage />,
      },
      {
        path: "hedeflerim",
        element: <HedeflerimPage />,
      },
      {
        path: "derslerim",
        element: <Derslerim />,
      },
      {
        path: "canli-dersler",
        element: <CanliDersler />,
      },
      {
        path: "canli-ders/:id/kayit",
        element: <CanliDersKayit />,
      },
      {
        path: "ders-kayitlari",
        element: <DersKayitlari />,
      },
      {
        path: "yoklama",
        element: <Yoklama />,
      },
      {
        path: "ders-programim",
        element: <DersProgramim />,
      },
      {
        path: "arama", element:<StudentSearch/>,
      },
      {path:"bildirimler",element:<Notifications/>},
      {
        path: "video-dersler",
        element: <VideoDersler />,
      },
      {
        path: "soru-bankasi",
        element: <SoruBankasi />,
      },
      {
        path: "soru-bankasi/test",
        element: <SoruBankasiTest />,
      },
      {
        path: "deneme-sinavlari",
        element: <DenemeSinavlari />,
      },
      {
        path: "deneme/:id",
        element: <DenemePage />,
      },
      {
        path: "deneme/:id/sonuc",
        element: <DenemeSonucPage />,
      },
      {
        path: "odevler",
        element: <Odevler />,
      },
      {
        path: "yanlis-sorularim",
        element: <YanlisSorularim />,
      },
      {
        path: "favorilerim",
        element: <Favorilerim />,
      },
      {
        path: "notlarim",
        element: <Notlarim />,
      },
      {
        path: "basari-analizim",
        element: <BasariAnalizim />,
      },
      {
        path: "ogretmenlerim",
        element: <Ogretmenlerim />,
      },
      {
        path: "mesajlar",
        element: <Mesajlar />,
      },
      {
        path: "sertifikalar",
        element: <Sertifikalar />,
      },
      {
        path: "paketim",
        element: <Paketim />,
      },
      {
        path: "profilim",
        element: <Profilim />,
      },
      {
        path: "*",
        element: <ComingSoon />,
      },
    ],
  },
  {
    path: "/ogretmen",
    element: <OgretmenLayout />,
    children: [
      { index: true, element: <OgretmenDashboard /> },
      { path: "ogrencilerim", element: <Ogrencilerim /> },
      { path: "derslerim", element: <OgretmenDerslerim /> },
      { path: "canli-dersler", element: <OgretmenCanliDersler /> },
      { path: "ders-programim", element: <OgretmenDersProgramim /> },
      { path: "video-dersler", element: <OgretmenVideoDersler /> },
      { path: "ai-video-ders", element: <AiVideoDers /> },
      { path: "soru-ekle", element: <SoruEkle /> },
      { path: "test-olustur", element: <TestOlustur /> },
      { path: "deneme-olustur", element: <DenemeOlustur /> },
      { path: "odevler", element: <OgretmenOdevler /> },
      { path: "ogrenci-analizleri", element: <OgrenciAnalizleri /> },
      { path: "ai-gecmisi", element: <OgretmenAiGecmisi /> },
      { path: "mesajlar", element: <OgretmenMesajlar /> },
      { path: "profil", element: <OgretmenProfil /> },
      { path: "*", element: <PanelNotFound homePath="/ogretmen" homeLabel="Ana panele" /> },
    ],
  },
  {
    path: "/veli",
    element: <VeliLayout />,
    children: [
      { index: true, element: <VeliDashboard /> },
      { path: "dersler", element: <VeliDersler /> },
      { path: "deneme-sonuclari", element: <VeliDenemeSonuclari /> },
      { path: "odevler", element: <VeliOdevler /> },
      { path: "devamsizlik", element: <VeliDevamsizlik /> },
      { path: "haftalik-rapor", element: <VeliHaftalikRapor /> },
      { path: "merakli-kontrolu", element: <VeliMerakliKontrolu /> },
      { path: "ai-analiz", element: <VeliAiAnaliz /> },
      { path: "mesajlar", element: <VeliMesajlar /> },
      { path: "profil", element: <VeliProfil /> },
      { path: "*", element: <PanelNotFound homePath="/veli" homeLabel="Ana panele" /> },
    ],
  },
  {
    path: "/yonetici",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "kullanicilar", element: <AdminKullanicilar /> },
      { path: "kurumlar", element: <InstitutionAdmin /> },
      { path: "roller", element: <AdminRoller /> },
      { path: "icerikler", element: <AdminIcerikler /> },
      { path: "canli-dersler", element: <AdminCanliDersler /> },
      { path: "sinavlar", element: <AdminSinavlar /> },
      { path: "paketler", element: <AdminPaketler /> },
      { path: "egitim-icerikleri", element: <LearningContent /> },
      { path: "odemeler", element: <AdminOdemeler /> },
      { path: "borclular", element: <AdminBorclular /> },
      { path: "sms-bildirim", element: <AdminSmsBildirim /> },
      { path: "destek", element: <AdminDestek /> },
      { path: "denetim-kaydi", element: <AdminDenetimKaydi /> },
      { path: "ayarlar", element: <AdminAyarlar /> },
      { path: "ai-yonetimi", element: <AiYonetimi /> },
      { path: "*", element: <PanelNotFound homePath="/yonetici" homeLabel="Ana panele" /> },
    ],
  },
  {
    path: "/admin",
    element: <Navigate to="/yonetici" replace />,
  },
  {
    path: "/admin/*",
    element: <LegacyAdminRedirect />,
  },
  {
    path: "/yonetim",
    element: <Navigate to="/yonetici" replace />,
  },
  {
    path: "/yonetim/*",
    element: <LegacyAdminRedirect />,
  },
  {
    path: "/egitimler",
    element: <CategoryPage data={categories.egitimler} />,
  },
  {
    path: "/canli-dersler",
    element: <CategoryPage data={categories["canli-dersler"]} />,
  },
  {
    path: "/soru-bankasi",
    element: <CategoryPage data={categories["soru-bankasi"]} />,
  },
  {
    path: "/deneme-sinavlari",
    element: <CategoryPage data={categories["deneme-sinavlari"]} />,
  },
  {
    path: "/ogretmenler",
    element: <CategoryPage data={categories.ogretmenler} />,
  },
  {
    path: "/hakkimizda",
    element: <About />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "/yardim",
    element: <Help />,
  },
  {
    path: "/paketler",
    element: <Paketler />,
  },
  {
    path: "/giris",
    element: <Giris />,
  },
  {
    path: "/ogretmen/giris",
    element: <OgretmenGiris />,
  },
  {
    path: "/yonetici/giris",
    element: <AdminGiris />,
  },
  {
    path: "/kayit",
    element: <Kayit />,
  },
  {
    path: "/sifremi-unuttum",
    element: <SifremiUnuttum />,
  },
  {
    path: "/sifre-sifirla",
    element: <SifreSifirla />,
  },
  {
    path: "/sinavlar",
    element: <Sinavlar />,
  },
  {
    path: "/sinavlar/:slug",
    element: <ExamDetailPage />,
  },
  { path: "/tyt", element: <ShortExamPage slug="tyt" /> },
  { path: "/ayt", element: <ShortExamPage slug="ayt" /> },
  { path: "/kpss", element: <ShortExamPage slug="kpss" /> },
  { path: "/lgs", element: <ShortExamPage slug="lgs" /> },
  { path: "/ales", element: <ShortExamPage slug="ales" /> },
  { path: "/dgs", element: <ShortExamPage slug="dgs" /> },
  { path: "/yds", element: <ShortExamPage slug="yds" /> },
  { path: "/yokdil", element: <ShortExamPage slug="yokdil" /> },
  { path: "/ydt", element: <ShortExamPage slug="ydt" /> },
  {
    path: "/siniflar",
    element: <Siniflar />,
  },
  {
    path: "/siniflar/:slug",
    element: <LevelDetailPage />,
  },
  {
    path: "/online-egitim",
    element: <OnlineDershane />,
  },
  {
    path: "/online-deneme-sinavi",
    element: <OnlineDenemeSinavi />,
  },
  {
    path: "/kvkk",
    element: <LegalPage slug="kvkk" />,
  },
  {
    path: "/gizlilik-politikasi",
    element: <LegalPage slug="gizlilik-politikasi" />,
  },
  {
    path: "/kullanici-sozlesmesi",
    element: <LegalPage slug="kullanici-sozlesmesi" />,
  },
  {
    path: "/cerez-politikasi",
    element: <LegalPage slug="cerez-politikasi" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
